module.exports = __webpack_public_path__ + "img/phone2.059e7349.png";